module.exports = __webpack_public_path__ + "img/variety.aeefef1e.svg";